<template>
  <div id="detail" class="full_layout detail" v-loading.fullscreen="loading" v-if="detailInfo!=null">
    <div class="breadcrumbANDsort">
      <div class="breadcrumb">
        <router-link :to="{path:'/'}">首页</router-link>
        <router-link :to="{path:'/market?f='+detailInfo.FirstCategoryId}" v-if="istype">{{detailInfo.FirstCategoryName}}</router-link>
        <router-link :to="{path:'/market?f='+detailInfo.FirstCategoryId+'&s='+detailInfo.SecondCategoryId}" v-if="istype">{{detailInfo.SecondCategoryName}}</router-link>
        <span>{{detailInfo.Title}}</span>
      </div>
    </div>
    <div class="productsDetail space_between">
      <card-swiper :imglist='imageList' :releaseType='detailInfo.ReleaseType' :presale='detailInfo.Presale' :status='detailInfo.Status' />
      <div class="detailText">
        <h2 class="h2">{{detailInfo.Title}}</h2>
        <div class="detailInfo">
          <!-- 即将上架 -->
          <div v-if="detailInfo.ReleaseType==1&&detailInfo.Presale!=1&&detailInfo.Status==2" class="presale">上架时间：{{detailInfo.LastOnTime|setTime}}</div>
          <!-- 即将上架 -->
          <div class="detailPrice" :class="detailInfo.QuantitySold>0&&detailInfo.Status>0?'':'out space_between'" v-if="detailInfo.Presale!=1">
            <!-- vip 价格 -->
            <span v-if="detailInfo.Price!=detailInfo.LowestPrice&&detailInfo.ReleaseType!=1&&detailInfo.QuantitySold>0&&detailInfo.Status>0">{{detailInfo.Price.toLocaleString()}}</span>
            <!--  <span class="del" v-if="detailInfo.Price!=detailInfo.LowestPrice&&detailInfo.ReleaseType!=1&&detailInfo.QuantitySold>0&&detailInfo.Status>0">{{detailInfo.Price.toLocaleString()}}</span> -->
            <!-- 非vip 价格 -->
            <span v-if="detailInfo.Price==detailInfo.LowestPrice&&detailInfo.ReleaseType!=1&&detailInfo.QuantitySold>0&&detailInfo.Status>0">{{detailInfo.Price.toLocaleString()}}</span>
            <!-- 预售 价格 -->
            <span v-if="detailInfo.ReleaseType==1" class="str">{{detailInfo.Price.toLocaleString()}}</span>
            <!-- 缺货 -->
            <span v-if="detailInfo.Price==detailInfo.LowestPrice&&detailInfo.QuantitySold<=0&&detailInfo.ReleaseType!=1&&detailInfo.Status==1&&detailInfo.HideType!=1" class="str">{{detailInfo.Price.toLocaleString()}}</span>
            <!-- 缺货vip价格 -->
            <div v-if="detailInfo.Status>-2">
              <span v-if="detailInfo.Price!=detailInfo.LowestPrice&&detailInfo.ReleaseType!=1&&detailInfo.Status<=0" class="str ">{{detailInfo.Price.toLocaleString()}}</span>
              <!-- <span class="del" v-if="detailInfo.Price!=detailInfo.LowestPrice&&detailInfo.QuantitySold<=0&&detailInfo.ReleaseType!=1&&detailInfo.Status<1">{{detailInfo.Price.toLocaleString()}}</span>text_red -->
            </div>
            <div v-if="detailInfo.Status<=-2">
              <span class="str">{{detailInfo.Price.toLocaleString()}}</span>
            </div>
            <div class="outOfStock" v-if="detailInfo.QuantitySold<=0&&detailInfo.ReleaseType!=1||detailInfo.Status<1">{{detailInfo.Status<=-2?'下架':'缺货'}}</div> 
          </div> <!-- 预售 -->
                <div class="detailPrice" :class="detailInfo.QuantitySold>0&&detailInfo.Status>0?'':'out space_between'" v-if="detailInfo.Presale==1">
                  <span>{{detailInfo.Price.toLocaleString()}}</span>
                  <div class="outOfStock" v-if="detailInfo.QuantitySold<=0&&detailInfo.ReleaseType!=1||detailInfo.Status<1">{{detailInfo.Status<=-2?'已售出':'缺货'}}</div> 
                  </div> 
                  <div class="detailBtn space_between" v-if='(detailInfo.QuantitySold>0&&detailInfo.Status>0)'>
                      <el-input-number v-model="quantitySold" @change="quantityChange" :min="1" :max="detailInfo.QuantitySold>=qty?qty:detailInfo.QuantitySold"></el-input-number>
                      <!-- 用户已登录 -->
                      <div class="detailBall" v-if="userInfo!=null">
                        <el-button @click="toCart($event,detailInfo)" v-if="detailInfo.Presale!=1">加入购物车</el-button>
                        <el-button type="primary" @click="goToPay(detailInfo)" v-if="detailInfo.Presale!=1&&detailInfo.Status==1">立即购买</el-button>
                        <el-button v-if="detailInfo.Presale==1" class="presale_btn" @click="goToPay(detailInfo)">立即付定金 <span class="advancePrice">{{setPrice(detailInfo.AdvancePrice,quantitySold)}}</span></el-button>
                      </div>
                      <!-- 用户未登录 -->
                      <div class="detailBall" v-if="userInfo==null">
                        <el-button @click="tologin()" v-if="detailInfo.Presale!=1">加入购物车</el-button>
                        <el-button type="primary" @click="tologin()" v-if="detailInfo.Presale!=1&&detailInfo.Status==1">立即购买</el-button>
                        <el-button v-if="detailInfo.Presale==1" class="presale_btn" @click="tologin()">立即付定金 <span class="advancePrice">{{setPrice(detailInfo.AdvancePrice,quantitySold)}}</span></el-button>
                      </div>
                  </div>
                </div>
                <div class="pack">
                  <div>包装描述</div>
                  <p class="explain_P" v-html="detailInfo.Explain"></p>
                </div>
                <div class="pack checklist" >
                  <el-button @click="checkList(detailInfo.CheckList)" v-if="detailInfo.CheckList">CHECK LIST</el-button>
                  <a class="el-button el-button--default" :href="detailInfo.CheckPdf" target="_blank" v-if="detailInfo.CheckPdf">PRODUCT PDF</a>

                </div>
            </div>
          </div>
          <div class="describe">
            <el-divider content-position="center">产品描述</el-divider>
            <div class="describeBox" v-html="detailInfo.Detail">
            </div>
          </div>
        </div>
</template>
<script>
import { getInfo, numMulti } from "@/api/public";
import CardSwiper from "@/components/swiper/card";
export default {
  name: 'detail',
  components: { CardSwiper },
  inject: ['reload'],
  data() {
    return {
      qty: process.env.vue_WEB_NUM, //可以加入购物车的数量上限
      loading: false,
      detailInfo: null,
      userInfo: getInfo(),
      quantitySold: 1,
      imageList: null,
      isId: 0,
      istype: false //判断是否需要面包屑
    }
  },
  filters: {
    setTime(val) {
      if (val != '' && val != undefined) {
        val = val.split(" ");
        val = val[0]
      }
      return val
    },
  },
  mounted() {
    this.$root.$on("closeDialog", (val, bol) => {
      this.userInfo = getInfo();
      this.$enumInfo.dislogType[val] = bol;
      if (this.userInfo != null) {
        this.reload();
      }
    })
  },
  created() {
    this.getPath();
    //this.toCartBox()
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    setPrice(num1, num2) {
      return numMulti(num1, num2)
    },
    getPath() {
      this.istype = this.$route.query.type != 1 ? true : false;
      this.isId = this.$route.params.id;
      this.getDetail();
    },
    tologin() {
      this.$enumInfo.dislogType.login = true
    },
    getDetail() {
      let that = this;
      that.loading = true;
      let data = { Id: that.isId }
      if (that.userInfo != null) {
        data = { Id: that.isId, MemberId: that.userInfo._id }
      }
      that.$get(that.$interface.GetCommodityById, data).then(res => {
        if (res.Result != 0) {
          that.detailInfo = res.Data;
          document.title = res.Data.Title + ' - 达咖文化'
          let imglist = [];
          if (res.Data.ImgList != null || res.Data.ImgList.length > 0) {
            res.Data.ImgList.map(it => {
              imglist.push(it.Url)
            })
          } else {
            //console.log(res.Data.TitImg,'res.Data.TitImg')
            imglist.push(res.Data.TitImg)
          }
          that.imageList = imglist
        }
        that.loading = false;
      })
    },
    toCart(e, obj) {
      let that = this;
      let data = { commodityId: obj._id, num: that.quantitySold, memberId: that.userInfo._id, Type: true }
      that.$post(that.$interface.AddMyCart, data).then(res => {
        if (res.Result != 0) {
          that.$root.$emit("newCart", "true");
          this.toCartBox(obj)
        } else {
          that.$message.error(res.Msg);
        }
      })
    },
    toCartBox(obj) {
      let that = this
      let title = '商品已成功加入购物车！';
      let html = '<div style="display: flex;">' +
        '<img style="width: 120px;height: 120px;object-fit: contain;border: 1px solid #F0F0F0;border-radius: 8px;margin-right: 10px;" src=' + (obj.TitImg||'') + ' />' +
        '<div style="width: 65%;">' + obj.Title + '<span style="display: block;">数量：' + that.quantitySold + '</span></div>' +
        '</div>'
      this.$confirm(html, title, {
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        lockScroll: false,
        confirmButtonText: '去购物车结算'
      }).then(() => {

        that.$root.$emit("newCart", "true");
        that.$router.push({ path: '/cart' })
      });
    },
    quantityChange() {

    },
    goToPay(obj) {
      //console.log(obj.TitImg,'obj.TitImg')
      let data = {
        Details: [{
          AdvancePrice: obj.AdvancePrice,
          Presale: obj.Presale,
          CommodityId: obj._id,
          CreateDate: obj.CreateDate,
          LowestPrice: obj.LowestPrice,
          Num: this.quantitySold,
          Price: obj.Price,
          PointsScore: obj.PointsScore,
          TitImg: obj.TitImg,
          Title: obj.Title,
          _id: obj._id,
          IsPoints: obj.IsPoints
        }]
      };
      window.sessionStorage.setItem('dakacheck', JSON.stringify(data))
      this.$router.push({ path: '/checkout' })
    },
    checkList(url) {
      window.location.href = url
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/detail.css";

.str {
  font-weight: 700;
}

.checklist {
  margin-top: 20px;
}

/*.h2:before {
  content: "即将上架";
}*/

</style>



// WEBPACK FOOTER //
// src/pages/market/item.vue